export const messages = {
  software: "Software",
  manual: "User Manuals",
  licenses: "Licenses",
};
